__turbopack_context__.v({
  "container": "styles-module-scss-module__Dx6OAG__container",
  "content": "styles-module-scss-module__Dx6OAG__content",
  "description": "styles-module-scss-module__Dx6OAG__description",
  "enter": "styles-module-scss-module__Dx6OAG__enter",
  "exit": "styles-module-scss-module__Dx6OAG__exit",
  "fade-in": "styles-module-scss-module__Dx6OAG__fade-in",
  "fade-out": "styles-module-scss-module__Dx6OAG__fade-out",
  "fade-out-80": "styles-module-scss-module__Dx6OAG__fade-out-80",
  "homeButton": "styles-module-scss-module__Dx6OAG__homeButton",
  "icon": "styles-module-scss-module__Dx6OAG__icon",
  "scrollArea": "styles-module-scss-module__Dx6OAG__scrollArea",
  "slide-in-from-bottom": "styles-module-scss-module__Dx6OAG__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__Dx6OAG__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__Dx6OAG__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__Dx6OAG__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__Dx6OAG__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__Dx6OAG__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__Dx6OAG__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__Dx6OAG__slide-out-to-top",
  "text": "styles-module-scss-module__Dx6OAG__text",
  "title": "styles-module-scss-module__Dx6OAG__title",
  "zoom-in": "styles-module-scss-module__Dx6OAG__zoom-in",
  "zoom-out": "styles-module-scss-module__Dx6OAG__zoom-out",
});
